import { JSX } from 'react';
import './style.scss';

function Checkbox({
  id,
  label,
  checked,
  onChange,
  className,
  disabled,
  helpText,
  interactiveHelpText = false,
}: {
  id: string;
  className?: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  helpText?: JSX.Element | string;
  interactiveHelpText?: boolean;
}) {
  return (
    <div className={`form-check ${className ?? ''}`}>
      <input type="checkbox" className="form-check-input" id={id} checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
      <label htmlFor={id} className="form-check-label fw-normal">
        {label}
      </label>
      {helpText && (
        <small id={`${id}-help-text`} className={`d-block checkbox__help-text ${interactiveHelpText ? 'checkbox__help-text--interactive' : ''}`}>
          {helpText}
        </small>
      )}
    </div>
  );
}

export default Checkbox;
